<div class="container-fluid">
    <app-report reportId="collectiveProductDashboard" screen="EXDASHPROD"></app-report>
  </div>
